(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aravi-smart-cart-feedback"] && !Shopify.designMode) return;
  try {
    (() => {
  const debug = new URLSearchParams(location.search).get('aravi_cart_debug') === '1';
  window.addEventListener('click', (event) => {
    if (event.button !== 0 || !(event.target instanceof Element)) return;
    const button = event.target.closest('button, input[type="submit"], [data-variant-id]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    const form = button.closest('form[action^="/cart/add"]');
    let variant;
    if (form && (button.type === 'submit' || button.name === 'add')) {
      if (!form.checkValidity()) return;
      variant = new FormData(form).get('id');
    } else if (button.matches('[data-variant-id]')) {
      const labels = ['add to cart', 'quick buy', 'add to bag'];
      if (!labels.includes(button.textContent.trim().toLowerCase()) && !labels.includes((button.getAttribute('title') || '').trim().toLowerCase())) return;
      variant = button.getAttribute('data-variant-id');
    }
    if (!variant || !/^\d+$/.test(String(variant))) return;
    if (!window.shiprocketSmartCartLoaded || typeof window.slideShiprocketSmartCartInFrame !== 'function' || typeof window.showLoader !== 'function') return;
    if (window.addToCartBehavior !== 'open_side_cart' || window.refetchSRSCOnOpen || window.srscListenForCartUpdates || window.srscShowShopifyBundleItems) return;
    const host = document.querySelector('[data-app="shiprocket-smart-cart"]');
    const drawer = host?.shadowRoot?.querySelector('.mini-cart-drawer');
    if (!drawer) return;
    const started = performance.now();
    if (debug) {
      host.dataset.araviCartFeedbackMs = '';
      host.dataset.araviCartSettledMs = '';
      const opened = new MutationObserver(() => {
        if (drawer.style.transform !== 'translateX(0px)' && drawer.style.transform !== 'translateX(0)') return;
        opened.disconnect();
        requestAnimationFrame(() => { host.dataset.araviCartFeedbackMs = String(Math.round(performance.now() - started)); });
      });
      opened.observe(drawer, { attributes: true, attributeFilter: ['style'] });
      const settled = new MutationObserver(() => {
        if (button.disabled) return;
        settled.disconnect();
        host.dataset.araviCartSettledMs = String(Math.round(performance.now() - started));
        const requests = performance.getEntriesByType('resource').filter(entry => entry.startTime >= started).flatMap(entry => {
          const url = new URL(entry.name, location.href);
          let step = '';
          if (url.origin === location.origin && /\/cart\/add(?:\.js)?$/.test(url.pathname)) step = 'shopify-add';
          else if (url.origin === location.origin && /\/cart\.js$/.test(url.pathname)) step = 'shopify-cart';
          else if (url.origin === location.origin && /\/variants\/[^/]+\.js$/.test(url.pathname)) step = 'variant-details';
          else if (url.hostname === 'edge.pickrr.com' && url.pathname.endsWith('/mini-cart/')) step = 'shiprocket-cart';
          if (!step) return [];
          return [{ step, startMs: Math.round(entry.startTime - started), durationMs: Math.round(entry.duration) }];
        });
        host.dataset.araviCartRequests = JSON.stringify(requests);
      });
      settled.observe(button, { attributes: true, attributeFilter: ['disabled'] });
      setTimeout(() => { opened.disconnect(); settled.disconnect(); }, 30000);
    }
    try {
      window.slideShiprocketSmartCartInFrame();
      window.showLoader();
    } catch (_) {}
  }, true);
})();

(() => {
  if (window.araviCartCountSync) return;
  window.araviCartCountSync = true;
  let timer;
  let running = false;
  let pending = false;
  let version = 0;
  const marker = 'aravi_count_sync';
  const endpoint = new URL((window.Shopify?.routes?.root || '/') + 'cart.js', location.origin);
  endpoint.searchParams.set(marker, '1');
  const paint = (count) => {
    if (!Number.isInteger(count) || count < 0) return;
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = count < 100 ? String(count) : '99+';
      const bubble = node.closest('.cart-count-bubble');
      const label = bubble?.querySelector('.visually-hidden');
      if (label) label.textContent = label.textContent.replace(/\d+/g, String(count));
    });
  };
  const sync = async () => {
    if (running) { pending = true; return; }
    running = true;
    const started = version;
    try {
      const response = await fetch(endpoint.href, { credentials: 'same-origin', cache: 'no-store' });
      if (response.ok) {
        const cart = await response.json();
        if (version === started) paint(cart.item_count);
      }
    } catch (_) {
    } finally {
      running = false;
      if (pending) { pending = false; schedule(); }
    }
  };
  const schedule = () => {
    version += 1;
    clearTimeout(timer);
    timer = setTimeout(sync, 80);
  };
  if ('PerformanceObserver' in window) {
    const observer = new PerformanceObserver((list) => {
      const changed = list.getEntries().some((entry) => {
        if (!['fetch', 'xmlhttprequest'].includes(entry.initiatorType)) return false;
        try {
          const url = new URL(entry.name, location.href);
          return url.origin === location.origin && !url.searchParams.has(marker)
            && /\/cart(?:\/(?:add|change|update|clear))?(?:\.js|\.json)?\/?$/.test(url.pathname);
        } catch (_) { return false; }
      });
      if (changed) schedule();
    });
    observer.observe({ type: 'resource', buffered: true });
  }
  document.addEventListener('cart:updated', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') schedule();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();
  } catch(e) { console.error(e); }
})();

})();
